<template>
  <el-dialog
      @close="closeDialog"
      class="add"
      :visible.sync="confirmVisible"
      width="500px"
      title="确认"
  >
    <div class="container" >
      <el-form ref="confiemForm" :model="confiemForm" label-width="100px">
        <el-row>
          <el-col :span="12">
            <el-form-item
                label="排序"
                size="small"
                prop="sort"
            >
              <el-input v-model="confiemForm.sort" placeholder="请填写排序，数值越小越靠前" style="width:300px"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item size="small">
              <el-button size="small" type="primary" @click="save"
              >保存</el-button
              >
              <el-button size="small" @click="closeDialog"
              >关闭</el-button
              >
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </el-dialog>
</template>
<script>
import * as oaApi from "@/http/oaApi.js";
export default {
  data() {
    return {
      confiemForm: {
        sort: ""
      },
    };
  },
  methods: {
    /**
     * 关闭对话框
     */
    closeDialog() {
      this.$emit("update:confirmVisible", false);
    },
    save() {
        oaApi
            .workOrdersConfirm(
                {
                  id: this.tableItem.id,
                  sort: this.confiemForm.sort
                },
                "post"
            )
            .then((res) => {
              this.confiemForm.sort = "";
              this.$message.success(`确认成功`);
              this.closeDialog();
              this.$parent.workOrdersList();
            });
    },
  },
  props: {
    confirmVisible: Boolean,
    tableItem: Object
  },
};
</script>
<style lang="scss">
.add {
  .el-dialog__body {
    padding: 20px 40px;
  }
  .el-steps {
    margin-bottom: 20px;
  }
  .el-input,
  .el-date-editor {
    width: 100%;
  }
  .el-form-item {
    .el-form-item__content {
      .el-radio {
        margin: 0;
        width: 100px;
      }
    }
  }
  .container {
    margin-top: 10px;
    .seccussImg {
      width: 80px;
      margin-top: 18px;
    }
    .seccussText {
      font-size: 18px;
      font-weight: bold;
      line-height: 2;
      margin-top: 18px;
    }
    .tableSchool,
    .tableHealth {
      .el-form-item--small.el-form-item {
        margin-bottom: 0;
      }
    }
  }
}
</style>
